import {Enum} from 'enumify';

class CutModes extends Enum {};

CutModes.initEnum([
    'chain', 'laser', 'chainPolished', 'frez'
]);

export default CutModes;
